export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

export function stringExtension () {
  String.prototype.replaceAll = function (search, replacement) {
    const target = this
    return target.split(search).join(replacement)
  }
  String.prototype.replaceAt = function(index, replacement) {
    return this.substr(0, index) + replacement + this.substr(index + replacement.length)
  }
}

export function unique (value, index, self) {
  return self.indexOf(value) === index
}

export function spansToString (spans, text) {
  return spans
    .map(x => text.substr(x[0], x[1] - x[0]).replaceAll('_', '').trim())
    .filter(unique)
    .join('\n')
}

/**
 * 清理空值，对象
 * @param children
 * @returns {*[]}
 */
export function filterEmpty (children = []) {
  return children.filter(c => c.tag || (c.text && c.text.trim() !== ''))
}

/**
 * 获取字符串长度，英文字符 长度1，中文字符长度2
 * @param {*} str
 */
export const getStrFullLength = (str = '') =>
  str.split('').reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0)
    if (charCode >= 0 && charCode <= 128) {
      return pre + 1
    }
    return pre + 2
  }, 0)

/**
 * 截取字符串，根据 maxLength 截取后返回
 * @param {*} str
 * @param {*} maxLength
 */
export const cutStrByFullLength = (str = '', maxLength) => {
  let showLength = 0
  return str.split('').reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0)
    if (charCode >= 0 && charCode <= 128) {
      showLength += 1
    } else {
      showLength += 2
    }
    if (showLength <= maxLength) {
      return pre + cur
    }
    return pre
  }, '')
}

export function convertTopicSpans (mapping, spans) {
  if (mapping.length === mapping[mapping.length - 1] + 1) { return spans }
  var output = []
  for (var item in spans) {
    var temp = {}
    for (var key in spans[item]) {
      var value = spans[item][key]
      temp[key] = value
      if (typeof (value) === 'number') {
        temp[key] = mapping[value]
      }
    }
    output.push(temp)
  }
  return output
}

export function convertEntitySpans (mapping, spans) {
  if (mapping.length === mapping[mapping.length - 1] + 1) { return spans }
  var output = {}
  for (var key in spans) {
    var temp = []
    for (var idx in spans[key]) {
      temp.push([mapping[spans[key][idx][0]], mapping[spans[key][idx][1]]])
    }
    output[key] = temp
  }
  return output
}

export function convertEntityConfidSpans (mapping, spans) {
  if (mapping.length === mapping[mapping.length - 1] + 1) { return spans }
  for (let key in spans) {
    for (let entity in spans[key]) {
      for (let idx in spans[key][entity]) {
        let span = spans[key][entity][idx]['span']
        spans[key][entity][idx]['span'] = [mapping[span[0]], mapping[span[1]]]
      }
    }
  }
  return spans
}

export function convertRelationSpans (mapping, spans) {
  if (mapping.length === mapping[mapping.length - 1] + 1) { return spans }
  var output = []
  for (var item in spans) {
    var temp = {}
    for (var key in spans[item]) {
      var value = spans[item][key]
      temp[key] = value
      if (value && typeof (value) === 'object') {
        temp[key] = convertEntitySpans(mapping, value)
      }
    }
    output.push(temp)
  }
  return output
}

function is32Bit (c) {
  return c.codePointAt(0) > 0xFFFF
}

export function getMapping (text) {
  var idx = -1
  var cursor = -1
  var mappingMtToUi = []
  var mappingUiToMt = []
  for (let c of text) {
    ++idx
    ++cursor
    mappingUiToMt[idx] = cursor
    mappingMtToUi[cursor] = idx
    if (is32Bit(c)) {
      ++idx
      mappingUiToMt[idx] = cursor
    }
  }
  return [mappingMtToUi, mappingUiToMt]
}

export function regulateBorder (total, index) {
  if (index < 0) return 0
  else if (index < total) return index
  else return total - 1
}

export function createSpan (text, start) {
  const left = start + text.length - text.trimLeft().length
  const right = start + text.trimRight().length
  return [left, right]
}

export function makeBase64 (data) {
  if (!data) return null
  else if (data.startsWith('data:')) return data
  else return 'data:image/jpg;base64,' + data
}

export async function loadImage (data) {
  const promise = {
    then: function (resolve, _reject) {
      const image = new Image()
      image.src = makeBase64(data)
      image.onload = () => {
        resolve(image)
      }
    }
  }
  return promise
}

export function downloadFile (content, filename) {
  const byteCharacters = atob(content)
  const sliceSize = 64 * 1024
  const byteArrays = []
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  const blob = new Blob(byteArrays, { type: 'application/octet-stream' })
  var link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
}

export async function clipImage (imageData, region) {
  if (region === null || imageData === null) return
  const image = await loadImage(imageData)
  const width = region[2] - region[0]
  const height = region[3] - region[1]

  const canvas = document.createElement('canvas')
  canvas.width = image.width
  canvas.height = image.height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(image, 0, 0)
  const data = ctx.getImageData(region[0], region[1], width, height)

  const canvas1 = document.createElement('canvas')
  canvas1.width = width
  canvas1.height = height
  const ctx1 = canvas1.getContext('2d')
  ctx1.rect(0, 0, width, height)
  ctx1.fillStyle = 'blue'
  ctx1.fill()
  ctx1.putImageData(data, 0, 0)
  const data1 = canvas1.toDataURL('image/jpeg')
  return data1.split('base64,')[1]
}

// 获取文件名
export function splitFileName (text) {
  var pattern = /\.{1}[a-z]{1,}$/
  if (pattern.exec(text) !== null) {
    return (text.slice(0, pattern.exec(text).index))
  } else {
    return text
  }
}

export function htmlEncode (str) {
  var s = ''
  if (str.length === 0) {
    return ''
  }
  s = str.replace(/</g, '&lt;')
  return s
}

export function htmlRestore (str) {
  var s = ''
  if (str.length === 0) {
    return ''
  }
  s = str.replace(/&lt;/g, '<')
  return s
}

export function getHtmlMapping (text) {
  const charMapping = {
    '<': '&lt;'.length
  }
  var idx = -1
  var cursor = -1
  var mappingTextToHtml = []
  var mappingHtmlToText = []
  for (let c of text) {
    ++idx
    ++cursor
    mappingHtmlToText[idx] = cursor
    mappingTextToHtml[cursor] = idx
    for (let i = 1; i < (charMapping[c] || 1); i += 1) {
      ++idx
      mappingHtmlToText[idx] = cursor
    }
  }
  return [mappingTextToHtml, mappingHtmlToText]
}

export function convertEntityHtmlSpans (mapping, spans) {
  if (!mapping || mapping.length === mapping[mapping.length - 1] + 1) { return spans }
  var output = []
  for (var item of spans) {
    const span0 = item[0]
    const span1 = item[1]
    output.push([mapping[span0], mapping[span1]])
  }
  return output
}

export function convertEntityHtmlSpan (mapping, span) {
  if (!mapping) return span
  else return [mapping[span[0]], mapping[span[1]]]
}

export function convertTopicHtmlSpans (mapping, tags) {
  if (!mapping || mapping.length === mapping[mapping.length - 1] + 1) { return tags }
  var output = []
  for (const item of tags) {
    let temp = {}
    temp.start = mapping[item.start]
    temp.end = mapping[item.end]
    temp.tags = item.tags
    output.push(temp)
  }
  return output
}
